<template>
  <div class="animated fadeIn list-of-unearnsettle">
    <b-card>
      <div slot="header">List Prepaid Allocation With Detail
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <!-- <b-button variant="primary mr-1" @click="edit" :disabled="(model.isvoid==1 || model.pbb_statustre==3)">Edit</b-button> -->
          <!-- <b-button variant="primary mr-1" @click="deleteConfirm" :disabled="(model.isvoid==1 || model.pbb_statustre==3)">Delete</b-button> -->
          <b-button variant="primary mr-1" @click="voidConfirm"
            :disabled="(model.isvoid == 1 || model.pbb_statustre == 3)">Void</b-button>
          <b-dropdown text="Posting/Unposting" variant="primary" class="mr-1">
            <!-- <b-dropdown-item @click="posting()">
              <i class="fa fa-file"></i>1 Trx. Selected
            </b-dropdown-item> -->
            <b-dropdown-item @click="showpostingbulkconfirm = true">
              <i class="fa fa-upload"></i>Posting Bulk by Current Filter
            </b-dropdown-item>
            <b-dropdown-item @click="showunpostingbulkconfirm = true">
              <i class="fa fa-download"></i>Unposting Bulk by Current Filter
            </b-dropdown-item>
          </b-dropdown>
          <!-- <b-button variant="primary mr-1" @click="printjv()"><i class="fa fa-print"></i> Print JV</b-button> -->
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-2">
        <b-col lg="7">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend><label class="label-custome">Allocation Date</label></b-input-group-prepend>
                <b-form-select v-model="tblData.optiondate" :plain="true" :options="dateOpt"></b-form-select>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label class="label-custome">Debitur</label></b-input-group-prepend>
                <b-form-input v-model="tblData.CustName" placeholder="Debitur Name"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label class="label-custome">Debitur No. (CIF)</label></b-input-group-prepend>
                <b-form-input v-model="tblData.CustCode" placeholder="Debitur No"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label class="label-custome">No. Kontark</label></b-input-group-prepend>
                <b-form-input v-model="tblData.no_kontrak" placeholder="Kontrak Name"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label class="label-custome">No Agreement</label></b-input-group-prepend>
                <b-form-input v-model="tblData.no_agreement" placeholder="Agreement No"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend><label style="width:115px;">Description</label></b-input-group-prepend>
            <b-form-input v-model="tblData.settleuraian"></b-form-input>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="12">
              <div class="text-right">
                <b-button variant="success" @click="refresh()"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button variant="secondary" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked" show-empty>
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th colspan="1" class="text-center"></b-th>
            <b-th variant="danger" colspan="9" class="text-center">PREPAID ALLOCATION</b-th>
            <b-th variant="primary" colspan="5" class="text-center">PREPAID PAYMENT</b-th>
          </b-tr>
        </template>
        <template v-slot:cell(action)="data">
          <b-dropdown dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret size="sm"
            style="margin:-10px;">
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(data.item.posting == 1)"
              style="padding:0 !important;">Edit</b-dropdown-item>
            <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting == 1)"
              style="padding:0 !important;">Posting</b-dropdown-item>
            <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting == 0)"
              style="padding:0 !important;">Un Posting</b-dropdown-item>
            <b-dropdown-item @click="rowPrint(data.item)" href="#" :disabled="(data.item.posting == 0)"
              style="padding:0 !important;">Print JV</b-dropdown-item>
            <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.posting == 1)"
              style="padding:0 !important;">
              Delete</b-dropdown-item>
          </b-dropdown>
        </template>
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>

        <template v-slot:cell(settleno)="data">
          <div :class="data.item.posting == 1 ? 'p-1' : 'bg-warning text-dark p-1'" v-b-tooltip.hover
            :title="data.item.posting == 0 ? '' : 'Data belum diposting'">{{ data.item.settleno }}</div>
        </template>
        <template v-slot:cell(tglsettl)="data">
          {{ data.item.tglsettl | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(post_settl)="data">
          {{ data.item.post_settl | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(tglpaym)="data">
          {{ data.item.tglpaym | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(post_paym)="data">
          {{ data.item.post_paym | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(settleamt)="data">
          {{ data.item.settleamt | numFormat('0,0.00') }}
        </template>
        <template v-slot:cell(tgl_terima)="data">
          {{ data.item.tgl_terima | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(totalbyr)="data">
          {{ data.item.matauang }}
          {{ data.item.totalbyr | numFormat('0,0.00') }}
        </template>
        <template v-slot:cell(pbb_amt)="data">
          {{ data.item.pbb_amt | numFormat('0,0.00') }}
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span v-else>{{
            tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols=4 label="Limit per page" style="margin-top:0 !important;">
            <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
              style="width:80px;" />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
      <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
      <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil
        open
      </p>
    </b-modal>
    <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
      <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
      <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
    </b-modal>

    <b-modal v-model="showpostingbulkconfirm" title="Posting Records?" :centered="true" @ok="postingbulk">
      <p class="mb-1">All record will be posting.</p>
      <!-- <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p> -->
    </b-modal>

    <b-modal v-model="showunpostingbulkconfirm" title="Unposting Records?" :centered="true" @ok="unpostingbulk">
      <p class="mb-1">All record will be unposting.</p>
      <!-- <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p> -->
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" hide-footer>
      <iframe :src="reportUrl" frameborder="0"></iframe>
      <b-row class="justify-content-center mt-1">
        <b-button variant="primary" v-if="(isprintjv == true)" @click.stop="editjv">Edit Journal</b-button>
        <b-button variant="secondary" class="ml-2" @click="showReport = false"> Close</b-button>
      </b-row>
    </b-modal>
    <b-modal v-model="showVoidConfirm" title="Void Transcation?" :centered="true" @ok="voidData">
      <p class="mb-1">1 record is about to be Void/Canceled/Reversed</p>
      <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-unearnsettle {
  table {
    td:nth-child(1) {
      width: auto;
    }

    td:nth-child(2) {
      width: auto;
    }

    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 120px;
    }
  }
}
</style>


<script>
import arsettlement from '../../apis/arsettlement';
import dropdown from "../../data/dropdown";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();


export default {
  data() {
    return {
      showFilter: true,
      showDelConfirm: false,
      showVoidConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      showpostingbulkconfirm: false,
      showunpostingbulkconfirm: false,
      horizontal: true,
      isLoading: false,
      isprintjv: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: {},
      items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: null,
        tgl2: null,
        sortBy: 'tglsettl',
        sortDesc: true,
        DimCol: 'Dim1', collector_id: '', optiondate: 'post'
      },
      user:this.$store.state.user,
      dataList: {
        arPayment: dropdown.arPayment
      },
      dateOpt: [{ value: 'post', text: 'Post Date' }, { value: 'value', text: 'Value Date' }],
    };
  },
  components: { Loading },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
        },
        {
          key: "settleno",
          variant: "danger",
          label: "Settle #",
          sortable: true
        },
        {
          key: "tglsettl",
          label: "Value Date",
          sortable: true
        },
        {
          key: "post_settl",
          label: "Post Date",
          sortable: true
        },
        {
          key: "no_agreement",
          label: "No Agreement",
        },
        {
          key: "no_kontrak",
          label: "No Kontrak",
        },
        {
          key: "CustName",
          label: "Debitur",
        },
        {
          key: "settleuraian",
          label: "Description",
        },
        {
          key: "settleamt",
          label: "Prepaid Allocation",
          thStyle: "width:120px",
          variant: "danger",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "createby",
          label: "Issued By",
          sortable: true
        },
        {
          key: "paymno",
          variant: "primary",
          label: "Payment Number",
          sortable: true
        },
        {
          key: "tglpaym",
          label: "Value Date",
          sortable: true
        },
        {
          key: "post_paym",
          label: "Post Date",
          sortable: true
        }
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    }
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function () {
    this.tblData.tgl1 = this.$store.state.timeServer[this.user.compcode];
    this.tblData.tgl2 = this.$store.state.timeServer[this.user.compcode];
  },
  methods: {
    data: async function (ctx) {
      try {
        this.isLoading = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.unearnsettle) {
          this.tblData[key] = filter.unearnsettle[key];
          filtered = true;
        }
        console.log('filtered',filtered)
        console.log('filter',filter)

        if (filtered === true) {
          this.tblData.tgl1 = filter.unearnsettle.tgl1 || '';
          this.tblData.tgl2 = filter.unearnsettle.tgl2 || '';
          this.showFilter = filtered;
          delete filter.unearnsettle;
          this.$store.commit("filter", filter);
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        console.log('this.tblData',this.tblData)
        const list = await arsettlement.list(this.tblData);
        this.items = list;
        this.isLoading = false;
        return list;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, 'ERROR MESSAGE', 10000);
        } else {
          toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
        }
      }
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.namabank = '';
      this.tblData.reference = '';
      this.tblData.uraian = '';
      this.tblData.nomor = '';
      this.tblData.customer = '';
      this.tblData.tgl1 = '';
      this.tblData.tgl2 = '';
      this.tblData.DimVal = '';
      this.tblData.tgldue1 = '';
      this.tblData.tgldue2 = '';
      this.tblData.status = '';
      this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];
      let filtered = false;
      const unearnsettle = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          unearnsettle[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        unearnsettle.page = this.tblData.page;
        unearnsettle.limit = this.tblData.limit;
        unearnsettle.sortBy = this.tblData.sortBy;
        unearnsettle.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.unearnsettle = unearnsettle;
        this.$store.commit("filter", filter);
      }
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.printjv();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete everything.', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value == true) {
            this.deleteData()
          }
        })

    },
    add() {
      this.saveFilter();
      router.push({ name: "loan.prepaidallocationform" });
    },
    edit: function () {
      if (this.model.settleKey) {
        this.saveFilter();
        router.push({ name: 'loan.prepaidallocationform', params: { settleKey: this.model.settleKey } });
      } else {
        toastr.warn('Please select a row that want to be Edit!');
      }
    },
    deleteConfirm() {
      if (this.model.settleKey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn('Please select a row that want to be Delete!');
      }
    },
    deleteData: async function () {
      try {
        this.isLoading = true;
        const data = await arsettlement.remove(this.model);
        this.isLoading = false;
        toastr.success(`Data has been deleted.`);
        this.refresh();
      } catch (error) {
        this.isLoading = false;
        toastr.error(error, 'ERROR MESSAGE', 10000);
      }
    },
    voidConfirm() {
      if (this.model.settleKey) {
        this.showVoidConfirm = true;
      } else {
        toastr.warn('Please select a row that want to be Void!');
      }
    },
    voidData: async function () {
      if (this.model.settleKey) {
        this.saveFilter();
        if (this.model.pbb_statustre == 3 || this.model.isvoid == 1) {
          toastr.warn('Transaksi sudah divoid.');
        } else {
          router.push(`reverse-prepaid-settlement-form/${this.model.settleKey}`);
        }

      } else {
        toastr.warn('Please select a row that want to be Edit!');
      }
    },
    rowClicked(record, index) {
      // if (this.model.settleKey == record.settleKey) {
      //     this.edit();
      // } else {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    postingbulk: async function () {
      try {
        this.isLoading = true;
        await arsettlement.postingbulk(this.tblData);
        this.refresh();
        this.isLoading = false;
        toastr.warn('Transaksi sudah diposting.');
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, 'ERROR MESSAGE', 10000);
        } else {
          toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
        }
      }
    },
    unpostingbulk: async function () {
      try {
        this.isLoading = true;
        await arsettlement.unpostingbulk(this.tblData);
        this.refresh();
        this.isLoading = false;
        toastr.warn('Transaksi sudah diun-posting.');
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, 'ERROR MESSAGE', 10000);
        } else {
          toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
        }
      }
    },
    posting: async function () {
      if (this.model) {
        if ((this.model.posting || 0) == 0) {
          this.showPostingConfirm = true;
        }
        if (this.model.posting == 1) {
          this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn('Please select a row that want to be Posted!');
      }
    },
    postingData: async function () {
      this.isLoading = true;
      try {
        await arsettlement.posting(this.model);
        this.model.posting = 1;
        // this.printjv();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, 'ERROR MESSAGE', 10000);
        } else {
          toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
        }
      }
    },
    unpostData: async function () {
      this.isLoading = true;
      try {
        await arsettlement.postingUndo(this.model);
        this.model.posting = 0;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, 'ERROR MESSAGE', 10000);
        } else {
          toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
        }
      }
    },
    editjv: function () {
      if (this.model.settleKey) {
        this.saveFilter();
        router.push({ name: 'loan.editjvfrm', params: { nomor: this.model.settleno, tanggal: this.model.tglsettl, kodejurnal: 'ARSTTL' } });
      } else {
        toastr.warn('Please select a row that want to be Edit!');
      }
    },

    printjv: async function () {
      if (this.model.settleKey) {
        // if ((this.model.posting || 0) == 0) {
        //       toastr.warn('Please do Posting first!');
        // }
        this.isLoading = true;
        try {
          if ((this.model.posting || 0) == 0) {
            await arsettlement.posting(this.model);
            this.model.posting = 1;
          }
          this.reportUrl = await arsettlement.printjv(this.model);
          this.isLoading = false;
          this.showReport = true;
          this.isprintjv = true;
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn('Please select a row that want to be Printed!');
      }
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        await arsettlement.exportXls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push({ name: 'loan.home' });
    }
  }
};
</script>
